var map = {
	"./b1_author.mp3": 906,
	"./b1_author_woah.mp3": 907,
	"./b1_p10_clickable.mp3": 908,
	"./b1_p10_clickable_b.mp3": 909,
	"./b1_p11_boomer.mp3": 910,
	"./b1_p11_clickable.mp3": 911,
	"./b1_p11_clickable_b.mp3": 912,
	"./b1_p11_crystal.mp3": 913,
	"./b1_p11_melody.mp3": 914,
	"./b1_p11_narration.mp3": 915,
	"./b1_p11_scout.mp3": 916,
	"./b1_p12_clickable.mp3": 917,
	"./b1_p13_boomer.mp3": 918,
	"./b1_p13_clickable.mp3": 919,
	"./b1_p13_clickable_b.mp3": 920,
	"./b1_p13_crystal.mp3": 921,
	"./b1_p13_melody.mp3": 922,
	"./b1_p13_narration.mp3": 923,
	"./b1_p13_scout.mp3": 924,
	"./b1_p14_clickable.mp3": 925,
	"./b1_p14_clickable_b.mp3": 926,
	"./b1_p15_boomer.mp3": 927,
	"./b1_p15_clickable.mp3": 928,
	"./b1_p15_clickable_b.mp3": 929,
	"./b1_p15_crystal.mp3": 930,
	"./b1_p15_melody.mp3": 931,
	"./b1_p15_narration.mp3": 932,
	"./b1_p15_scout.mp3": 933,
	"./b1_p16_clickable.mp3": 934,
	"./b1_p1_boomer.mp3": 935,
	"./b1_p1_clickable.mp3": 936,
	"./b1_p1_crystal.mp3": 937,
	"./b1_p1_melody.mp3": 938,
	"./b1_p1_narration.mp3": 939,
	"./b1_p1_scout.mp3": 940,
	"./b1_p2_clickable.mp3": 941,
	"./b1_p3_boomer.mp3": 942,
	"./b1_p3_clickable.mp3": 943,
	"./b1_p3_clickable_b.mp3": 944,
	"./b1_p3_crystal.mp3": 945,
	"./b1_p3_melody.mp3": 946,
	"./b1_p3_narration_b.mp3": 947,
	"./b1_p3_scout.mp3": 948,
	"./b1_p5_boomer.mp3": 949,
	"./b1_p5_crystal.mp3": 950,
	"./b1_p5_melody.mp3": 951,
	"./b1_p5_narration.mp3": 952,
	"./b1_p5_scout.mp3": 953,
	"./b1_p6_clickable.mp3": 954,
	"./b1_p7_boomer.mp3": 955,
	"./b1_p7_clickable.mp3": 956,
	"./b1_p7_clickable_b.mp3": 957,
	"./b1_p7_crystal.mp3": 958,
	"./b1_p7_melody.mp3": 959,
	"./b1_p7_narration.mp3": 960,
	"./b1_p7_scout.mp3": 961,
	"./b1_p8_clickable.mp3": 962,
	"./b1_p9_boomer.mp3": 963,
	"./b1_p9_clickable.mp3": 964,
	"./b1_p9_clickable_b.mp3": 965,
	"./b1_p9_crystal.mp3": 966,
	"./b1_p9_melody.mp3": 967,
	"./b1_p9_narration_b.mp3": 968,
	"./b1_p9_scout.mp3": 969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 905;